<template>
    <div>
        <VJoyInput
            v-model="searchQuery"
            autocomplete="off"
            icon="search"
            name="searchOwner"
            :placeholder="$t('projectclient.quote.view.project-team.dialog.project-owner.search.placeholder')"
            type="search"
        />
        <div
            class="change-overlay__list-company-members"
            :style="{'--dynamic-height': filteredMembers && filteredMembers.length > 2 ? '200px' : '100px'}"
        >
            <VJoyHighlight v-if="!filteredMembers?.length" level="neutral" :accent="false">
                <template #default>
                    <h3 class="change-overlay__empty-state">
                        {{ $t('projectclient.quote.view.project-team.dialog.project-owner.no.members.label') }}
                    </h3>
                    <p v-html="$t('projectclient.quote.view.project-team.dialog.project-owner.no.members.explanation')"></p>
                </template>
            </VJoyHighlight>
            <VJoyWrapper v-else no-margin class="change-overlay__radio-buttons">
                <VJoyRadioGroup direction="vertical">
                    <VJoyRadio
                        v-for="member in filteredMembers"
                        :key="member.identityId"
                        v-model="newIdentityId"
                        :value="member.identityId"
                        name="change-owner"
                    >
                        <VJoyWrapper no-margin column-gap="3">
                            <VJoyAvatar size="small" :photo-url="member.photoUrl" :full-name="`${member.firstName} ${member.lastName}`" />
                            {{ member.firstName }} {{ member.lastName }}
                        </VJoyWrapper>
                    </VJoyRadio>
                </VJoyRadioGroup>
            </VJoyWrapper>
            <VJoyFormError v-if="newIdentityIdErrors?.length" :errors="newIdentityIdErrors" />
        </div>
        <br />
        <h3>{{ $t('projectclient.quote.view.project-team.dialog.project-owner.email.label') }}</h3>
        <p>{{ $t('projectclient.quote.view.project-team.dialog.project-owner.email.explanation') }}</p>
        <VJoyInput
            v-model="invitationEmail"
            name="addEmail"
            :placeholder="$t('projectclient.quote.view.project-team.dialog.project-owner.email.placeholder')"
            type="email"
        ></VJoyInput>
        <VJoyFormError v-if="emailErrors?.length" :errors="emailErrors" />
    </div>
</template>

<script lang="ts" setup>
    import {VJoyAvatar, VJoyFormError, VJoyHighlight, VJoyInput, VJoyRadio, VJoyRadioGroup, VJoyWrapper} from '@maltjoy/core-vue';
    import type {ClientCompanyMemberResource} from '@api';

    defineProps<{
        currentQuoteOwner: string;
        filteredMembers?: ClientCompanyMemberResource[];
        emailErrors?: string[];
        newIdentityIdErrors?: string[];
    }>();

    const newIdentityId = defineModel<string>('newIdentityId');
    const invitationEmail = defineModel<string>('invitationEmail');
    const searchQuery = defineModel<string>('searchQuery');
</script>

<style lang="scss" scoped>
    :deep(.joy-radio-label) {
        align-items: center;
        margin-bottom: var(--joy-core-spacing-2);
    }

    .change-overlay {
        &__subheader {
            font-size: var(--joy-font-size-primary-400);
        }

        &__list-company-members {
            height: var(--dynamic-height, 200px);
            margin-top: var(--joy-core-spacing-6);

            :deep(a) {
                color: var(--joy-color-secondary-30);
            }
        }

        &__empty-state {
            margin-bottom: var(--joy-core-spacing-1);
        }

        &__radio-buttons {
            height: var(--dynamic-height, 200px);
            padding-left: var(--joy-core-spacing-2);
            overflow-y: auto;
        }
    }
</style>
